import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative" data-id="element-148">
      <div className="max-w-3xl mx-auto text-center" data-id="element-149">
        <FadeIn data-id="element-150">
          <Quote className="w-12 h-12 text-zinc-700 mx-auto mb-8 opacity-50" data-id="element-151" />
          <p className="text-2xl sm:text-3xl font-serif italic leading-relaxed text-zinc-200" data-id="element-152">
            En solo 7 días, pasarás de la fatiga de decisión a una claridad
            cortante. Notarás cómo el "ruido" en tu cabeza baja de volumen y tu
            cuerpo recupera una ligereza que habías olvidado.
          </p>
        </FadeIn>
      </div>
    </section>;
}